module.exports = __webpack_public_path__ + "media/images/mailer/activation_customer/png/load_data_en-78b1af9fb053d7d52ce563d0ae278c62.png";